// Constantes y tipos extraídos de PendingGenerationsContext.tsx
// Mantener esto en un archivo separado permite que React Fast Refresh
// funcione correctamente en el contexto (que solo debe exportar componentes/hooks).

export type Cuerpo = 'secretaria' | 'c1' | 'c2' | 'iipp' | 'guardia_civil' | 'policia_nacional';
export type GenType = 'test' | 'case' | 'flashcard' | 'presentation' | 'infographic' | 'report';
export type GenStatus = 'generating' | 'ready' | 'seen' | 'error';

export interface PendingGen {
  id: string;
  type: GenType;
  cuerpo: Cuerpo;
  topic: string;
  status: GenStatus;
  resultId?: string;
  route: string;
  fullRoute?: string;
  createdAt: number;
  errorMessage?: string;
  artifactUrl?: string;
}

export const STORAGE_KEY = 'munilex.pending_generations.v1';
export const MAX_KEEP = 20;
export const TTL_MS = 1000 * 60 * 60 * 24;

export const cuerpoToExamType: Record<Cuerpo, string> = {
  secretaria: 'oposiciones',
  c1: 'c1',
  c2: 'c2',
  iipp: 'iipp',
  guardia_civil: 'guardia_civil',
  policia_nacional: 'policia_nacional',
};

export const cuerpoToBaseRoute: Record<Cuerpo, string> = {
  secretaria: '/app/oposiciones',
  c1: '/app/oposiciones-c1',
  c2: '/app/oposiciones-c2',
  iipp: '/app/oposiciones-iipp',
  guardia_civil: '/app/guardia-civil',
  policia_nacional: '/app/policia-nacional',
};

export const CUERPO_BASE_ROUTES = cuerpoToBaseRoute;
